import Colors from './colors';
import Fonts from './fonts';
import FontWeights from './fontWeights';
import LineHeights from './lineHeights';

export default {
  Colors,
  Fonts,
  FontWeights,
  LineHeights
};
